import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { GreenLandscape, LightGrayTranslucentCloud, DarkGrayCloud, Sun } from '@sunrun/component-library/illustrations';
import { MIN_DESKTOP_BREAKPOINT } from '../general/constants/_breakpoints';
import { PRODUCT_BACKGROUND } from '../general/constants/_colors';
import { Header } from '../general';

const Unknown = styled.div`
  position: relative;
  overflow: hidden;
  height: 100%;

  > div:first-of-type {
    // set height because no text
    height: ${({ showTopNavbar }) => (showTopNavbar ? '60px' : '220px')};
  }

  @media only screen and (min-width: ${MIN_DESKTOP_BREAKPOINT}) {
    height: ${({ showTopNavbar }) => (showTopNavbar ? 'auto' : '100%')};

    > div:first-of-type {
      // hide header on desktop
      display: ${({ showTopNavbar }) => (showTopNavbar ? 'none' : 'block')};
    }
  }
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  padding-top: 350px;
  text-align: center;
  font-size: 18px;

  div {
    max-width: 750px;
  }
`;

const TopIllustration = styled.div`
  position: absolute;
  top: 60px;
  right: 0;
  width: 450px;
  height: 220px;

  svg {
    position: absolute;
  }

  @media only screen and (min-width: ${MIN_DESKTOP_BREAKPOINT}) {
    top: 0;
    right: 10%;
  }
`;

const StyledSun = styled(Sun)`
  left: 42%;
  top: 20px;
`;

const moveClouds = left => keyframes`
  0% { transform: translateX(${left}px); }
  100% { transform: translateX(0px); }
`;

const StyledLightGrayTranslucentCloud = styled(LightGrayTranslucentCloud)`
  bottom: 0;
  left: 0%;
  animation: ${moveClouds(-100)} 20s ease 1;
`;

const StyledDarkGrayCloud = styled(DarkGrayCloud)`
  top: 0;
  right: 0%;
  margin-left: 20px;
  animation: ${moveClouds(40)} 15s ease 1;
`;

const BottomIllustration = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -10px;
`;

const FullScreenError = ({ message, showTopNavbar }) => (
  <Unknown showTopNavbar={showTopNavbar}>
    {showTopNavbar && <Header backgroundColor={PRODUCT_BACKGROUND} title=" " showMainIconMobile />}
    <TopIllustration>
      <StyledSun width="120px" height="120px" />
      <StyledLightGrayTranslucentCloud width="300px" />
      <StyledDarkGrayCloud width="270px" />
    </TopIllustration>
    <Content>
      <div>{message || 'Oops - it looks like there was an error that occurred in the application. Sorry about that.'}</div>
    </Content>
    <BottomIllustration>
      <GreenLandscape />
    </BottomIllustration>
  </Unknown>
);

FullScreenError.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  showTopNavbar: PropTypes.bool,
};

FullScreenError.defaultProps = {
  message: '',
  showTopNavbar: false,
};

export default FullScreenError;
